import { ResourceUtils } from '../ResourceUtils';

export class FlowCardUtils {
  static isZoneCard(card) {
    return card?.ownerUri.startsWith('homey:zone:') ?? false;
  }

  static isMoodCard(card) {
    return card?.ownerUri.startsWith('homey:mood:') ?? false;
  }

  static isDeviceCard(card) {
    return card?.ownerUri.startsWith('homey:device:') ?? false;
  }

  static isAppCard(card) {
    return card?.ownerUri.startsWith('homey:app:') ?? false;
  }

  static isManagerCard(card) {
    return card?.ownerUri.startsWith('homey:manager:') ?? false;
  }

  static getOwnerType(card) {
    switch (true) {
      case FlowCardUtils.isZoneCard(card):
        return 'zone';
      case FlowCardUtils.isDeviceCard(card):
        return 'device';
      case FlowCardUtils.isAppCard(card):
        return 'app';
      case FlowCardUtils.isManagerCard(card):
        return 'manager';
      default:
        return null;
    }
  }

  static getTitle(card) {
    if (card == null) return '';

    // todo:
    // homey-core support
    const zoneName = card.uriObj?.meta?.zoneName;
    return `${ResourceUtils.getOwnerName(card) ?? ''}${zoneName ? ` - ${zoneName}` : ''}`;
  }

  static generateAdvancedFlowCardData(card) {
    return {
      ownerUri: card.ownerUri,
      id: card.id,
      droptoken: card.droptoken ? null : undefined,
      args:
        card.args?.reduce((accumulator, arg) => {
          accumulator[arg.name] = arg.value ?? undefined;
          return accumulator;
        }, {}) ?? undefined,
    };
  }

  static generateFlowCardDataIdProperties(card) {
    return {
      id: card.id,
    };
  }
}
